import React, { useState, useEffect } from 'react';
import { useSearchParam } from "react-use";
import cc from "classcat";

import { Button, Modal } from '../../index';
import FeedbackForm from '../../forms/FeedbackForm';
import { useFormModal } from '../../../hooks/useFormModal';

interface Props {
  className?: string;
}

const FeedbackButton = ({ className }: Props) => {
  const queryParam = useSearchParam('openFeedback');
  const { isOpen: feedbackModal, openModal, closeModal } = useFormModal(['feedbackForm']);
  const [localModal, setLocalModal] = useState<boolean>(false);

  // Handle legacy openFeedback parameter
  useEffect(() => {
    if (queryParam !== null) {
      setLocalModal(true);
    }
  }, [queryParam]);

  const isModalOpen = feedbackModal || localModal;

  const handleClick = () => {
    if (localModal) {
      setLocalModal(false);
    } else {
      openModal();
    }
  };

  const handleClose = () => {
    setLocalModal(false);
    closeModal();
  };

  return (
    <>
        <Button onClick={handleClick} className={cc([className, 'newStyleButtonOverrideSolid'])} type="solidOrange" large>
        Provide Feedback
      </Button>
      <Modal isOpen={isModalOpen} onRequestClose={handleClose} overrideTitle="Feedback">
        <FeedbackForm />
      </Modal>
    </>
  );
};

export default FeedbackButton;
